import store from 'src/vuex/store.js'

const state     = {
  leftNavShow : false,
  rightNavShow : false,
}
const getters   = {}
const mutations = {
  showLeftNav (state) {
    state.leftNavShow = true
  },
  showRightNav (state) {
    state.rightNavShow = true
  },
  hideLeftNav (state) {
    state.leftNavShow = false
  },
  hideRightNav (state) {
    state.rightNavShow = false
  },
  toggleLeftNav (state) {
    state.leftNavShow = !state.leftNavShow
  },
  toggleRightNav (state) {
    state.rightNavShow = !state.rightNavShow
  },
  setLeftNav (state, payload) {
    state.leftNavShow = payload.state
  },
  setRightNav (state, payload) {
    state.rightNavShow = payload.state
  },
}
const actions   = {}

store.registerModule('App', {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
})
